import { Feedback } from './Feedback';
export class CheckForFailure {
  constructor(failureMessage, pattern) {
    this.failureMessage = failureMessage;
    this.pattern = pattern;
  }
  feedbackForAnswer(answer) {
    if (this.pattern === undefined) {
      return new Feedback(false, this.failureMessage);
    }
    if (answer.compare(this.pattern)) {
      return new Feedback(false, this.failureMessage);
    }
    return null;
  }
}